import { type TFunction } from 'i18next'

interface FormButtonText {
	isLastStep: boolean
	isBusy: string
	formHasBeenCompleted: boolean
	formCompletedText: string
	t: TFunction
}

export const getButtonText = ({
	isLastStep,
	isBusy,
	formCompletedText,
	formHasBeenCompleted,
	t,
}: FormButtonText) => {
	if (isBusy !== 'idle') {
		return t('general.wait')
	}

	if (formHasBeenCompleted) {
		return formCompletedText
	}

	return isLastStep ? t('general.submit') : t('general.next')
}
